module.exports = __webpack_public_path__ + "img/hd.da7663d1.png";